
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import TextField from '../../../../framework/fields/TextField.vue';
import PercentageField from '../../../../framework/fields/PercentageField.vue';
import DateField from '../../../../framework/fields/DateField.vue';
import { sharedState } from '../../../../framework/state';
import { getResource, putResource } from '../../../../framework/client/resource';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { VatRate } from '../../../../../common/application/model/VatRate';
import { successToast, errorToast } from '../../../service/toast_service';
import { isOverlappingVatRate } from '../../../service/vat_rate_service';

@Component({
    components: { PercentageField, TextField, DateField, ValidationObserver },
})
export default class EditVatRate extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VAT_RATE;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as VatRate,
    };

    // Functions
    async mounted() {
        this.local.row = (await getResource<VatRate>(this.resourceType, this.id))!!;
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    private async saveResource(goBack: boolean) {
        const isValid = await isOverlappingVatRate(this.local.row);
        if (!isValid) {
            errorToast(this, 'message.overlappingVatRates');
            return;
        }

        try {
            await putResource<VatRate>(this.resourceType, this.id, this.local.row);
            successToast(this, 'message.vatRateSaved');
            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
